<template>
  <div class="page-loading">
    <div class="mask" @click.stop="" @touchmove.stop.prevent=""></div>
    <loadingIcon />
  </div>
</template>

<script>
import loadingIcon from './loadingIcon'
export default {
  name: 'pageLoaidng',
  components: {
    loadingIcon
  }
}
</script>

<style lang="scss">
  .page-loading {
    position: fixed;
    z-index: 3000;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    .mask {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      background: transparent;
    }
    .loader {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 160px;
      height: 160px;
      transform: translate(-50%, -50%);
    }
  }
</style>
